"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import {
  CalendarDays,
  CheckSquare,
  Wallet,
  MapPin,
  BookOpen,
  Settings,
} from "lucide-react";
import { cn } from "@/lib/utils";

export function TripBottomNav({ tripId }: { tripId: string }) {
  const pathname = usePathname();
  const base = `/trips/${tripId}`;

  const navItems = [
    { href: base, label: "일정", icon: CalendarDays },
    { href: `${base}/checklist`, label: "준비물", icon: CheckSquare },
    { href: `${base}/budget`, label: "비용", icon: Wallet },
    { href: `${base}/map`, label: "지도", icon: MapPin },
    { href: `${base}/journal`, label: "기록", icon: BookOpen },
    { href: `${base}/settings`, label: "설정", icon: Settings },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 block border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 sm:hidden print:hidden pb-[env(safe-area-inset-bottom)]">
      <div className="flex h-14 items-center justify-around px-1">
        {navItems.map((item) => {
          const active = pathname === item.href;
          const Icon = item.icon;
          return (
            <Link
              key={item.href}
              href={item.href}
              className={cn(
                "flex flex-1 flex-col items-center justify-center gap-1 py-1 text-[11px] font-medium transition-colors",
                active
                  ? "text-primary font-semibold"
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <Icon className={cn("size-4", active && "scale-110 transition-transform")} />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
